import { Accordion, AccordionSummary } from "@mui/material";
import * as React from "react";
import { useSelector } from "react-redux";
import { MenuItemEntity } from "../../../../entities/UIEntities/MenuItem";
import { MENU_ITEMS, ROLES_HIERARCHY} from "../../../../enums/Enums";
import Icons from "../../../../resources/icons/Icons";
import {
  handleDeletePermission,
  handleEditPermissions,
} from "../../../../utils/MenuUtils";
import FacilityRoleCard from "../../Cards/FacilityCard/FacilityRoleCard";
import CustomMenu from "../../Menus/CustomMenu/CustomMenu";
import classes from "../Accordion.module.css";

const FacilityRoleAccordion = (props) => {
  const userScpoe = props.userScopes.find(
    (scope) => scope.scopeId === props.scope.id 
  );
  const validRole = useSelector((state) => {
    return state.user.gmtUser?.role?.hierarchy}
    ) <= ROLES_HIERARCHY.ADMINISTRATOR


  const roleName = userScpoe?.role?.name;
  const menuItems = [
    new MenuItemEntity(
      MENU_ITEMS.EDIT_PERMISSIONS,
      handleEditPermissions,
      true,
      Icons.EDIT_ITEM,
      false,
      {...props, selectedScopeId : userScpoe?.scopeId}
    ),
    new MenuItemEntity(
      MENU_ITEMS.DELETE,
      handleDeletePermission,
      false,
      Icons.DELETE_ITEM,
      true,
      {...props, userScopeId : userScpoe?.id}
    ),
  ];

  return (
    <div className={classes.cardContainer}>
      <Accordion defaultExpanded className={classes.accordion} expanded={false}>
        <AccordionSummary
          aria-controls={props.scope.id}
          id={props.scope.id}
          className={classes.accordionSummary}
          classes={{ content: classes.menu }}
        >
          <FacilityRoleCard
            {...props}
            expanded={false}
            roleName={roleName}
          ></FacilityRoleCard>
          {validRole && <CustomMenu menuItems={menuItems}></CustomMenu>}
        </AccordionSummary>
      </Accordion>
    </div>
  );
};

export default FacilityRoleAccordion;
